export const isValidPhone = (number: string) => {
  if (number == null || number == "") {
    return false;
  }
  let pattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  return pattern.test(number) && number.length === 14;
};

export const isValidEmail = (email: string) => {
  if (email == null || email == "") {
    return false;
  }
  let pattern =
    /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  return pattern.test(email);
};

export const isValidPassword = (password: string) => {
  if (password == null || password == "") {
    return false;
  }
  let pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,20}$/;
  return pattern.test(password);
};

export const isNumber = (value: string) => {
  return /^\d+$/.test(value);
};

export const isDateInRange = (start: string, end: string) => {
 
  const startDate = new Date(Number(start));
  const endDate =
    end !== null && typeof end !== "undefined" ? new Date(Number(end)) : null;
 
  const today = new Date();
  if (endDate === null) {
    return today >= startDate;
  } else {
    return today >= startDate && today <= endDate;
  }
};
